import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-second-opinion',
  templateUrl: './online-second-opinion.component.html',
  styleUrls: ['./online-second-opinion.component.css']
})
export class OnlineSecondOpinionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
